// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageWithArtistPillButton_container__2Y9RL","pill":"ImageWithArtistPillButton_pill__1QQYz"};